"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function confirmPasswordValidator(model) {
    return function (control) {
        return model.password !== control.value ? { 'sameString': { value: control.value } } : null;
    };
}
exports.confirmPasswordValidator = confirmPasswordValidator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcGFyZS1wYXNzd29yZC12YWxpZGF0b3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb21wYXJlLXBhc3N3b3JkLXZhbGlkYXRvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUdBLGtDQUF5QyxLQUEwQjtJQUMvRCxPQUFPLFVBQUMsT0FBd0I7UUFDNUIsT0FBTyxLQUFLLENBQUMsUUFBUSxLQUFLLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUMsWUFBWSxFQUFFLEVBQUMsS0FBSyxFQUFFLE9BQU8sQ0FBQyxLQUFLLEVBQUMsRUFBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7SUFDNUYsQ0FBQyxDQUFDO0FBQ04sQ0FBQztBQUpELDREQUlDIn0=


//////////////////
// WEBPACK FOOTER
// ./src/app/user-selection/edit-user/compare-password-validator.ts
// module id = 629
// module chunks = 0